import Login from '@viewsE/login';
import Main from '@viewsE/main';

const basePath = 'esim/';
export const esimAppRouter = [
    {path: basePath + 'login', component: Login},
    {path: basePath + 'main', component: Main},
];
